/* eslint-disable no-alert */ /* eslint-disable no-nested-ternary */
<template>
  <div class="cs-payment">
    <loader ref="loader" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  AUTH_EXCHANGE,
} from "@/store/modules/user/consts";

export default {
  data() {
    return {
      popup: null,
    };
  },
  async mounted() {
    this.$nextTick(async () => {
      this.$refs?.loader?.start();
      if (this.$route.query.code) {
        let requestPayload = {
          code: this.$route.query.code,
          redirect: `${window.location.origin}/`,
        };
        requestPayload = this.Encrypt({ requestPayload });
        const data = {
          name: "coinbase",
          requestPayload,
        };
        await this.$store.dispatch(`user/${AUTH_EXCHANGE}`, data);
        this.popup = window.open(
          "",
          "exchange_connect",
          `width=585, height=800, top=${(window.screen.height - 800) / 2
          }, left=${(window.screen.width - 585) / 2}, _blank`
        );
        if (this.popup) {
          this.popup.focus();
          this.popup.close();
        }
        this.popup = null;
      } else if (this.hostedPageId) {
        this.$router.push({ name: 'HostedPage', params: { id: this.hostedPageId } })
      } else if ((!this.hostedPageId && !window.location.pathname.includes('hostedPage'))) {
        this.invalidOrder()
      }
    });
  },
  computed: {
    ...mapGetters({
      cart: "user/cart",
      hostedPageId: "user/getHostedPageId"
    }),
  },
};
</script>

<style lang="scss" scoped></style>
